import { styled } from 'styled-components';
import { device, Utils } from 'team-hero-ui';

const { pxToRem } = Utils;

export const EmptyFieldStyled = styled.div`
  min-height: ${pxToRem(60)};
  display: none;
  @media ${device.sm} {
    display: block;
  }
`;
